module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image6a.64be8248.jpg";